import React, { useCallback, useEffect, useState } from 'react';
import { BASE_URL } from '../../../constant/api';
import { Link, useNavigate } from 'react-router-dom';
import { FaStar, FaRegStar, FaStarHalfAlt } from 'react-icons/fa';
import axios from 'axios';
import { useSession } from '../../../ApiCalls/useSession';
import { IoCloseSharp, IoHeartOutline, IoHeartSharp } from 'react-icons/io5';
import AddToCartModel from '../AddToCartModel/AddToCartModel';

function CategoryViewProductCard({ product }) {

    const rating = product.product_rating || 0;
    const totalStars = 5;


    useSession()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [quantity, setQuantity] = useState(0);
    const [wishlist, setWishlist] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Open Modal
    const openModal = useCallback((product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
    }, []);

    // Close Modal
    const closeModal = useCallback(() => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    }, []);

    useEffect(() => {
        const getWishlist = async () => {
            const token = localStorage.getItem("token");
            const sessionId = localStorage.getItem("sessionid");
            const headers = token
                ? { Authorization: `Token ${token}` }
                : { "Session-Id": sessionId };
            // console.log(headers);

            try {
                const response = await axios.get(`${BASE_URL}/products/wishlist/`, {
                    headers,
                });
                setWishlist(response.data.items.map((item) => item.product_id));
                // console.log(response)
            } catch (error) {
                console.error("Error fetching wishlist:", error);
            }
        };

        getWishlist();
    }, []);

    // Toggle Wishlist
    const toggleWishlist = async (product_id) => {
        try {
            const isWishlisted = wishlist.includes(product_id);
            const token = localStorage.getItem("token");
            const sessionId = localStorage.getItem("sessionid");
            const headers = token
                ? { Authorization: `Token ${token}` }
                : { "Session-Id": sessionId };
            // console.log(headers);

            const res = await axios.post(
                `${BASE_URL}/products/wishlist/`,
                { product_id },
                { headers }
            );

            // console.log(res);

            setWishlist((prev) =>
                isWishlisted
                    ? prev.filter((id) => id !== product_id)
                    : [...prev, product_id]
            );
        } catch (error) {
            console.error("Error toggling wishlist:", error);
        }
    };

    const handleDeleteWishlistItem = async (productId) => {
        const token = localStorage.getItem("token");
        let sessionId = localStorage.getItem("sessionid");

        const headers = token
            ? { Authorization: `Token ${token}` }
            : { "Session-Id": sessionId };

        // console.log(headers);

        try {
            const response = await axios.delete(`${BASE_URL}/products/wishlist/${productId}/`, {
                // data: { product_id: productId },
                headers,
            });

            if (response.data.Status === "1") {
                // Assuming `wishlist` is a state variable
                setWishlist((prev) => prev.filter((id) => id !== productId));
                console.log("Item deleted successfully:", response.data);
            } else {
                console.error("Unexpected response:", response.data);
            }
        } catch (error) {
            console.error(`Error deleting item ${productId}:`, error);
        }
    };



    // Add to Cart
    const addToCart = async (product, quantity) => {
        if (!product || !product.id) {
            console.error("Invalid product or missing product ID");
            return;
        }
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            const sessionId = localStorage.getItem("sessionid");
            const headers = token
                ? { Authorization: `Token ${token}` }
                : { "Session-Id": sessionId };
            // console.log(headers);

            // Check if the selected quantity is not equal to the minimum order quantity
            if (quantity === 1) {
                quantity = product.min_order_quantity; // Reset quantity to min_order_quantity if it's not equal
            }

            // console.log(product.id, ":af:", quantity)
            await axios.post(
                `${BASE_URL}/orders/cart/`,
                {
                    product_id: product.id,
                    quantity: quantity
                },
                { headers }
            );

            navigate("/cart");
            closeModal();
        } catch (error) {
            console.error("Error adding product to cart:", error);
        } finally {
            setLoading(false);
        }
    };

    // Function to render the stars
    const renderStars = (rating) => {
        const filledStars = Math.floor(rating); // Number of full stars
        const hasHalfStar = rating % 1 >= 0.5; // For half stars
        const emptyStars = totalStars - filledStars - (hasHalfStar ? 1 : 0); // Empty stars
        
        return (
            <>
                {[...Array(filledStars)].map((_, index) => (
                    <FaStar key={`filled-${index}`} className="text-yellow-500 w-5 h-5" />
                ))}
                {hasHalfStar && <FaStarHalfAlt className="text-yellow-500 w-5 h-5" />}
                {[...Array(emptyStars)].map((_, index) => (
                    <FaRegStar key={`empty-${index}`} className="text-gray-400 w-5 h-5" />
                ))}
            </>
        );
    };



    return (
        
        <div className="rounded-lg p-2 sm:p-6 w-full h-auto border-2 boarder-gray-200">
            <div className="bg-whiterounded-lg w-full h-fit p-5">
                <div className="flex justify-between items-center text-sm text-brand-light-gray mb-5">
                    {(product.offer_percent || product.offer_percent === null) && (
                        <span className="">
                            {product.offer_percent ? <span className="bg-red-600 rounded-lg p-1 px-2">{product.offer_percent}%</span> : <span className="bg-transparent"></span>}
                        </span>
                    )}


                   <span
                     className="text-red-700 text-2xl cursor-pointer"
                     onClick={() =>
                       wishlist.includes(product.id)
                         ? handleDeleteWishlistItem(product.id)
                         : toggleWishlist(product.id)
                     }
                   >
                     {wishlist.includes(product.id) ? (
                       <IoHeartSharp />
                     ) : (
                       <IoHeartOutline />
                     )}
                   </span>
                 </div>
                <Link to={`/product-details/${product.id}`}>
                    <img
                        src={
                            product.product_images?.[0]?.image
                                ? product.product_images[0].image.startsWith(BASE_URL)
                                    ? product.product_images[0].image
                                    : `${BASE_URL}${product.product_images[0].image}`
                                : '/images/default-product.png'
                        }
                        alt={product.name || 'Product'}
                        className="mb-2 h-24 sm:h-32 md:h-48 w-full object-contain transition transform hover:scale-105"
                        onError={(e) => {
                            e.target.src = '/images/default-product.png';
                        }}
                    />
                </Link>
            </div>
            <Link to={`/product-details/${product.id}`} className="text-black hover:text-green-500">
                <h2 className="text-sm sm:text-lg  font-semibold mt-2 sm:mt-4 line-clamp-1 hover:text-green-500">
                    {product.name}
                    {/* ({product.category})({product.subcategory}) */}
                </h2>
            </Link>
            <p className="line-clamp-1 text-sm text-gray-600">
                {product.description || "No description available"}
            </p>
            <div className="flex items-center mt-1 sm:mt-2 space-x-1">
                {renderStars(rating)}
                <p className="text-gray-500 text-xs sm:text-sm ml-2">
                    {product.product_rating} ({product.product_review_count} Reviews)
                </p>
            </div>
            <div className="flex items-center justify-between space-x-2 mt-1 sm:mt-2">
              <div className='flex justify-center items-center gap-2'>
                    <p className="text-sm sm:text-lg font-bold">{product.currency_symbol}{product.price}</p>
                    <p className="text-gray-500 line-through text-xs sm:text-sm">
                        {product.currency_symbol}{product.actual_price}
                    </p>
              </div>
                <span
                    className="rounded-lg bg-brand-primary py-1 px-2 text-xs text-white cursor-pointer"
                    onClick={() => openModal(product)}
                >
                    ADD
                </span>
            </div>

            {/* Product Modal */}
            <AddToCartModel
                selectedProduct={selectedProduct}
                isModalOpen={isModalOpen}
                closeModal={closeModal}
            />

        </div>
    );
}


export default CategoryViewProductCard;
